import React, { useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Checkbox } from 'antd';
import GradientLegend from 'features/MapSection/components/MapLeftBar/components/GradientLegend';
import LayersAndResolutions from 'data/layers/LayersAndResolutions.json';
import DiscreteColorLegend from './DiscreteColorLegend';
import useActiveLayersStore from 'stores/useSelectedLayersStore';

const LayerMenuCategory = ({
    title,
    isCollapsed,
    toggleCategory,
    categoryKey,
    items,
    handleChangeResolution,
    checkButtonSelected,
    handleCheckboxClick,
    isLayerSelected
}) => {
    const selectedLayers = useActiveLayersStore((state) => state.selectedLayers);
    const [areItemsOpen, setAreItemsOpen] = useState(
        items.map(() => false)
    );
    const [areDescriptionsOpen, setAreDescriptionsOpen] = useState(
        items.map(() => false)
    );

    const handleItemClick = (index) => {
        const newItemsOpen = [...areItemsOpen]; // Creating a shallow copy of the array.
        newItemsOpen[index] = !newItemsOpen[index];

        setAreItemsOpen(newItemsOpen);
    };

    const handleDescriptionClick = (index) => {
        const newDescriptionsOpen = [...areDescriptionsOpen]; // Creating a shallow copy of the array.
        newDescriptionsOpen[index] = !newDescriptionsOpen[index];

        setAreDescriptionsOpen(newDescriptionsOpen);
    };

    return (
        <>
            <div
                className="windy-style-category"
                onClick={(e) => toggleCategory(categoryKey, e)}
            >
                <span><b>{title}</b></span>
                <DownOutlined className={`arrow-icon ${isCollapsed ? '' : 'up'}`} />
            </div>

            <div className={`windy-style-category-content ${isCollapsed ? 'collapsed' : ''}`}>
                {
                    items.map((item, index) => {
                        const layer = LayersAndResolutions.layers.find((layer) => layer.longName == item.key);
                        return (
                            <div className={`windy-style-item ${selectedLayers.includes(item.key) ? 'active' : ''} ${areItemsOpen[index] ? 'expanded' : ''}`} key={item.key}>
                                <div
                                    className="windy-style-item-header"
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        handleItemClick(index);
                                    }}
                                >

                                    <div className="windy-style-layer-title">
                                        <div className="windy-style-layer-icon">
                                            <img src={item.iconUrl} alt={item.key} />
                                        </div>

                                        <div className="windy-style-layer-info">
                                            <div className="windy-style-layer-name">
                                                {layer?.displayName ?? item.key}

                                                <div className='windy-style-layer-expand'>
                                                    <DownOutlined />
                                                </div>
                                            </div>

                                            <div className="windy-style-layer-product">{item.productName}</div>
                                        </div>

                                    </div>

                                    <div
                                        className="windy-style-layer-checkbox"
                                        onClick={async (e) => {
                                            e.stopPropagation();
                                            await handleCheckboxClick(item.key)
                                        }}
                                    >
                                        <label onClick={((e) => e.stopPropagation())} className="rounded-checkbox">
                                            <input type="checkbox" onClick={(e) => e.stopPropagation()} onChange={async () => await handleCheckboxClick(item.key)} checked={isLayerSelected(item.key)} />
                                        </label>
                                    </div>

                                </div>

                                {
                                    areItemsOpen && areItemsOpen[index] && (
                                        <div className="windy-style-options">
                                            <div className="windy-style-option-group">
                                                <div className="windy-style-option-title">{ layer.spaceResolutionCustomTitle ? layer.spaceResolutionCustomTitle : "Spatial resolution" }</div>
                                                <div className="windy-style-option-buttons">
                                                    {

                                                        layer.spaceResolution.map(spaceResolution => {
                                                            const isSelected = checkButtonSelected(item.key, 'space', spaceResolution);
                                                            return (
                                                                <button
                                                                    key={spaceResolution}
                                                                    disabled={!selectedLayers.includes(item.key)}
                                                                    className={`windy-style-option-button ${isSelected ? 'selected' : ''}`}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleChangeResolution(item.key, 'space', spaceResolution);
                                                                    }}
                                                                >
                                                                    { spaceResolution }
                                                                </button>
                                                            );
                                                        })

                                                    }
                                                </div>
                                            </div>
                                            <div className="windy-style-option-group">
                                                <div className="windy-style-option-title">Temporal Resolution</div>
                                                <div className="windy-style-option-buttons">
                                                    {
                                                        layer.timeResolution.map(timeResolution => {
                                                            const isSelected = checkButtonSelected(item.key, 'time', timeResolution);
                                                            return (
                                                                <button
                                                                    key={timeResolution}
                                                                    disabled={!selectedLayers.includes(item.key)}
                                                                    className={`windy-style-option-button ${isSelected ? 'selected' : ''}`}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleChangeResolution(item.key, 'time', timeResolution);
                                                                    }}
                                                                >
                                                                    {timeResolution}
                                                                </button>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>

                                            <div className="windy-style-legend">
                                                {
                                                    layer.gradientColors ? (
                                                        <GradientLegend colors={layer.gradientColors} />
                                                    ) : (
                                                        <DiscreteColorLegend colors={layer.discreteColors} />
                                                    )
                                                }
                                            </div>


                                            {
                                                layer.description && (
                                                    <div className={`windy-style-description ${areDescriptionsOpen[index] ? "expanded" : ""}`}>
                                                        <button onClick={() => handleDescriptionClick(index)}>Learn more...</button>
                                                        <div className="windy-style-description-content" dangerouslySetInnerHTML={{__html: layer.description}}></div>
                                                    </div>
                                                )
                                            }

                                        </div>
                                    )
                                }

                            </div>
                        )
                    })
                }
            </div>
        </>
    );
};

export default LayerMenuCategory;